import { Injectable } from '@angular/core';
import { User } from '@src/app/_models/user/user';
import { AuthenticationService } from '@src/app/_services/authentication.service';
import { Hotline } from '@src/app/_models/hotline/hotline';
import { Hotliner } from '@src/app/_models/hotline/hotliner';

@Injectable({
    providedIn: 'root',
})
export class PermissionService {
    currentUser: User | null;

    constructor(private readonly authenticationService: AuthenticationService) {}

    // eslint-disable-next-line complexity
    viewHotline(hotline: Hotline): boolean {
        let state: boolean;

        if (
            hotline.created_by === this.authenticationService.currentUserValue?.id ||
            this.authenticationService.currentUserValue?.rule?.is_hotline_admin ||
            this.authenticationService.currentUserValue?.rule?.is_admin
        ) {
            state = true;
        } else if (hotline.hotliner.user.id === this.authenticationService.currentUserValue?.id) {
            state = true;
        } else {
            state = true;
        }

        return state;
    }

    checkUserISHotliner(hotliners: Hotliner[]): boolean {
        let iAmHotliner = false;

        hotliners.forEach((hotliner: Hotliner) => {
            if (
                hotliner.user_id === this.authenticationService.currentUserValue?.id &&
                !hotliner.deleted_date
            ) {
                iAmHotliner = true;
            }
        });

        return iAmHotliner;
    }

    checkUserISAdmin(user: User): boolean {
        let iAmAdmin = false;

        if (user.rule?.is_admin) {
            iAmAdmin = true;
        }

        return iAmAdmin;
    }

    checkUserISHotlineAdmin(user: User): boolean {
        let iAmAdmin = false;

        if (user.rule?.is_admin || user.rule?.is_hotline_admin) {
            iAmAdmin = true;
        }

        return iAmAdmin;
    }

    checkUserISAdministrative(user: User): boolean {
        let iAmAdmin = false;

        if (user.rule?.is_admin || user.rule?.is_administrative) {
            iAmAdmin = true;
        }

        return iAmAdmin;
    }
}
